import { InjectionToken } from '@angular/core';

import { QuestionInputTypeComponentMap } from '../interfaces/questionnaire.interface';

export const QUESTION_INPUT_TYPE_COMPONENTS = new InjectionToken<QuestionInputTypeComponentMap[]>(
  'Components for the question type component'
);
